var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPerson(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.5C15.0376 14.5 17.5 12.0376 17.5 9C17.5 5.96243 15.0376 3.5 12 3.5C8.96243 3.5 6.5 5.96243 6.5 9C6.5 12.0376 8.96243 14.5 12 14.5Z",
    fill: "#E6E5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.36683 17.248C6.242 16.4489 7.42899 16 8.66667 16H15.3333C16.571 16 17.758 16.4489 18.6332 17.248C19.5083 18.047 20 19.1308 20 20.2609V21.7826C20 22.455 19.403 23 18.6667 23C18.1212 23 5.87877 23 5.33333 23C4.59695 23 4 22.455 4 21.7826V20.2609C4 19.1308 4.49167 18.047 5.36683 17.248Z",
    fill: "#B1B0F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3727 3.22059C12.4613 3.22059 13.7849 3.40343 14.3133 3.65312C14.41 2.13553 15.7496 0.75 17.3094 0.75C18.8692 0.75 20.25 2.05021 20.25 3.65312C20.25 5.25603 18.4953 6.74518 16.9499 6.30882C17.3388 7.13974 17.568 7.80426 17.568 8.77941C17.568 9.69159 17.568 10.0147 16.9499 11.25C16.9499 11.25 16.3317 10.9412 15.7135 10.0147C15.7135 10.0147 15.2125 9.20604 15.1364 8.77941C15.0582 8.34465 15.124 8.2587 15.087 7.82191C15.0479 7.377 14.8298 6.97271 14.3133 7.1007C11.3727 7.82597 8.23778 7.87473 6.75 6.74518C7.75214 4.39464 9.53178 3.22059 11.3727 3.22059Z",
    fill: "#8E8CEE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.5221739a6662f3f1afc718d79a940ad0.svg";
export { ForwardRef as ReactComponent };